"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
/* istanbul ignore next */
import React from "react"
import { ApolloWrapper } from "../lib/apollo/ApolloWrapper"
import { ThemeProvider } from "@mui/material/styles"
import { AppRouterCacheProvider } from "@mui/material-nextjs/v16-appRouter"
import theme from "../lib/theme"

// AppRouterCacheProvider collects the Emotion/MUI CSS generated during SSR and
// flushes it into <head> via useServerInsertedHTML while Next.js streams the
// response. Options preserve the previous cache config (key "css", prepend: true)
// so class names and Tailwind-override ordering are unchanged.
function Providers({ children }) {
  return (
    <AppRouterCacheProvider options={{ key: "css", prepend: true }}>
      <ApolloWrapper>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </ApolloWrapper>
    </AppRouterCacheProvider>
  )
}

export default Providers
